export const SET_REFRESH_TOKEN_INTERVAL = 'SET_REFRESH_TOKEN_INTERVAL';